"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATUS_LIST = void 0;
var status_1 = require("@caddigital/sok-reducers/lib/status");
exports.STATUS_LIST = [
    status_1.RequestStatusValue.STANDBY,
    status_1.RequestStatusValue.BUSY,
    status_1.RequestStatusValue.SUCCESS,
    status_1.RequestStatusValue.FAILURE
];
